// extracted by mini-css-extract-plugin
module.exports = {"footnote":"footnote_footnote__dOh8a","heading":"footnote_heading__Savet","body":"footnote_body__GQ2iq"};